import React from 'react';
import CtaButton from '../ctaButton/ctaButton';
import styles from './errorBoundary.module.scss';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    // Define a state variable to track whether is an error or not
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI

    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can use your own error logging service here
    // eslint-disable-next-line no-console
    console.log({ error, errorInfo });
  }

  render() {
    // Check if the error is thrown
    const { hasError } = this.state;
    if (hasError) {
      // You can render any custom fallback UI
      return (
        <div className={styles.container}>
          <div className={styles.section}>
            <p className={styles.message}>Oops, there is an error!</p>
            <CtaButton
              color="red"
              label="Try again?"
              onClick={() => this.setState({ hasError: false })}
            />
          </div>
        </div>
      );
    }

    // Return children components in case of no error
    const { children } = this.props;
    return children;
  }
}

export default ErrorBoundary;
